import React from "react";
import {  Button, Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { CCAssessmentType } from "../../Physician/Models/CCEnrollment";
import { CertificationGeneration } from "../../Physician/Models/Certificate";
import { deepCopy } from "../../Shared/Utility/DeepCopy";
import { CcAssessmentPathwayEnrollmentCertificate } from "../Models/CcAssessmentPathwayEnrollment";
import { getDateWithOffset } from "../../Shared/Utility/GetDateWithOffset";

interface IProps{
    certificate: CcAssessmentPathwayEnrollmentCertificate;
    updateEnrollmentCert: (certificate: CcAssessmentPathwayEnrollmentCertificate) => void;
}
export default function SelectCertificationRow(props: IProps){
    const updateCcAssessmentType = (ccAssessmentType: CCAssessmentType) => {
        var updatedCert = deepCopy(props.certificate);
        updatedCert.ccAssessmentType = ccAssessmentType;
        if (ccAssessmentType !== CCAssessmentType.Article){
            updatedCert.lastArticleAssessmentEnrolledDate = new Date().toString();
        } else{
            updatedCert.lastArticleAssessmentEnrolledDate = null;
        }
        
        props.updateEnrollmentCert(updatedCert);
    }

    const updateCertIsEnrolled = (isEnrolled: boolean) => {
        var updatedCert = deepCopy(props.certificate);
        updatedCert.isEnrolled = isEnrolled;
        if (!isEnrolled){
            updatedCert.ccAssessmentType = null;
        }
        
        props.updateEnrollmentCert(updatedCert);
        
    }
    
    return (
        <React.Fragment>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <strong>{props.certificate.certificationName}</strong>
                            {props.certificate.isEnrolled && props.certificate.isFuture && <div className="subscript">(Requirements Begin: {getDateWithOffset(props.certificate.enrollmentStartDate).toLocaleDateString('en-US')})</div>}
                            
                        </Col>
                        <Col>
                            <Form.Group>
                            {props.certificate.isEnrolled  ? 
                            <React.Fragment>
                                {props.certificate.isAbccEligible ? <React.Fragment>
                                    <Form.Text className="font-weight-bold">Select pathway<span className="text-pp-primary ml-2">*</span>
                                    <OverlayTrigger
                                        placement={"right"}
                                        overlay={<Tooltip id="selectPathwayToolTip" bsPrefix="pp-tooltip">
                                            <p><strong>Article Based Continuing Certification (ABCC): </strong>Diplomates will complete a set of mini exams based on articles from various medical journals per 3-year block</p>
                                            <p><strong>Exam Pathway: </strong>Diplomates will be required to apply for and pass a traditional recertification examination every ten years</p>
                                        </Tooltip>}>
                                        <i className="las la-info-circle ml-1 text-pp-secondary"></i>
                                    </OverlayTrigger>
                                    </Form.Text>
                                    

                                        <Form.Group controlId={(props.certificate.certificateId.toString()) + "-articleControls"}>
                                            <Form.Check key={CCAssessmentType.Article} type="radio">
                                                <Form.Check.Input type="radio"
                                                    checked={props.certificate.ccAssessmentType === CCAssessmentType.Article}
                                                    disabled={!props.certificate.isAbccStillAvailable} 
                                                    data-tip={!props.certificate.isAbccStillAvailable ? "ABCC Pathway not available for this certification" : "Article Based Continuing Certification (ABCC)"}
                                                    onChange={() => updateCcAssessmentType(CCAssessmentType.Article)} />
                                                <Form.Check.Label className="mb-1 pp-font-size-smaller">Article Based Continuing Certification (ABCC) Pathway</Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                        <Form.Group controlId={(props.certificate.certificateId.toString()) + "-examControls"}>
                                            <Form.Check key={CCAssessmentType.Exam} type="radio">
                                                <Form.Check.Input type="radio"
                                                    checked={props.certificate.ccAssessmentType === CCAssessmentType.Exam}
                                                    data-tip="Exam Pathway"
                                                    onChange={() => updateCcAssessmentType(CCAssessmentType.Exam)} />
                                                    
                                                <Form.Check.Label className="mb-1 pp-font-size-smaller">Exam Pathway</Form.Check.Label>
                                            </Form.Check>
                                        </Form.Group>
                                    </React.Fragment> : 
                                        <React.Fragment>
                                            <span>ABPN's ABCC pathway is not an option for this certification. Please see the <a target="_BLANK" href="https://abpn.org/maintain-certification/taking-a-cc-exam/subspecialty-cc-exams/">ABPN Website</a> for more details.</span>
                                        </React.Fragment>}
                                    </React.Fragment> 
                                    : 
                                    <React.Fragment>
                                        {props.certificate.certificationGeneration === CertificationGeneration.Lifetime 
                                            && !props.certificate.isEnrolled &&
                                            <div>
                                                <Button type="button" variant="pp-primary" onClick={() => updateCertIsEnrolled(true)}>Enroll This Certification Into CC (Optional)</Button>
                                            </div>}

                                        
                                </React.Fragment>}
                            </Form.Group>
                        </Col>
                        <Col>
                                {props.certificate.certificationGeneration === CertificationGeneration.Lifetime 
                                && props.certificate.isEnrolled &&
                                    <div>
                                        <Button type="button" variant="pp-primary" onClick={() => updateCertIsEnrolled(false)}>Unenroll This Certification From CC</Button>
                                    </div>
                                }
                        </Col>
                    </Row>
                </Col>
            </Row>
            <hr />
        </React.Fragment>)
}